import type { FeatureRoute } from '@/shared/registry'

import { bulkEditUsersPath, userBulkEditRoute } from './paths'

/** Bulk Edit and a bulk edit's report (SM-35). Find Users opens Bulk Edit with its search. */
export const userBulkEditRoutes: readonly FeatureRoute[] = [
  {
    path: bulkEditUsersPath,
    titleId: 'siteManagement.userBulkEdits.create.title',
    page: () => import('./BulkEditUsersPage').then((module) => module.BulkEditUsersPage),
  },
  {
    path: userBulkEditRoute,
    titleId: 'siteManagement.userBulkEdits.details.title',
    page: () => import('./UserBulkEditPage').then((module) => module.UserBulkEditPage),
  },
]
